import {ObjectUtil} from '../../util/object-util';

export class Company {
  companyId: string = null;
  name: string = null;
  street: string = null;
  houseNumber: string = null;
  postalCode: string = null;
  location: string = null;
  countryCode: string = null;
  countryName: string = null;
  telephoneNumber: string = null;
  faxNumber: string = null;
  emailAddress: string = null;
  seatNumber: string = null;
  companyRole: string = null;
  kisUsername: string = null;
  kisPassword: string = null;

  constructor(object?: any) {
    ObjectUtil.assign(this, object);
  }
}
